export default "__VITE_ASSET__qIOYD4PL__"